import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

export const getInsights = async () => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/insights`,
    { headers: getAuthHeaders() }
  );

  return response.data;
};

export const getInsightById = async (insight_id: string) => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/insights/${insight_id}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

const getAuthHeaders = () => ({ Authorization: getAuthUser()?.accessToken });
